export const TRIAL_LOOM_VIDEOS = {
  inviteClient:
    'https://www.loom.com/embed/90255565dc404610846adecbd7d82049?hide_owner=true&hide_share=true&hide_title=true&hideEmbedTopBar=true',
  intakeForm:
    'https://www.loom.com/embed/90255565dc404610846adecbd7d82049?hide_owner=true&hide_share=true&hide_title=true&hideEmbedTopBar=true',
  reviewResults:
    'https://www.loom.com/embed/ba5e6a8ee0ea43af948f2b3f9acd3cc6?hide_owner=true&hide_share=true&hide_title=true&hideEmbedTopBar=true',
};
